import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import { useMemo } from "react"
import { useIntl } from "react-intl"
import type { RadioOption } from "src/components"

export const useLanguageOptions = (): RadioOption[] => {
	const { formatDisplayName } = useIntl()
	const { availableLocales } = useDealerContext()

	return useMemo(
		(): RadioOption[] =>
			availableLocales.map((value) => {
				const languageCode = value.split("-")[0]
				const displayName = formatDisplayName(languageCode, { type: "language" })
				return {
					label: displayName ?? languageCode,
					value,
				}
			}),
		[formatDisplayName, availableLocales],
	)
}
